module.exports = __webpack_public_path__ + "img/2000018.77af69c8.png";